<div class="col-lg-12">
    <div id="top-text-title">
        Partners
    </div>
    <div id="partners-list">
        <div class="container">
            <div class="row partner-container">
                <div class="col-lg-12">
                    <div class="partner-container-title">
                        Bulgarian Chamber of Commerce and Industry - Stara Zagora
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12">
                    <div class="container partner-box">
                        <div class="row">
                            <div class="col-lg-2 col-sm-12 small-center-align">
                                <div class="justify-content-center align-self-center partner-container-image">
                                    <img src="../../assets/images/bcc_stz.png" height="110" width="200">
                                </div>
                            </div>
                            <div class="col-lg-10 col-sm-12">
                                <div class="justify-content-center ">
                                    <div class="partner-container-content">
                                        <div class="partner-container-text">
                                            "Smart Century Technologies" is a member of "Bulgarian Chamber of Commerce and Industry" - Stara Zagora.<br><br>
                                            "Bulgarian Chamber of Commerce and Industry" - Stara Zagpra is a leading business organization that unites over 200 companies operating in Stara Zagora municipality.<br><br>
                                            Visit <a href="https://www.chambersz.com/">website.</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row partner-container">
                <div class="col-lg-12">
                    <div class="partner-container-title">
                        BASSCOM – Bulgarian Association of Software Companies
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12">
                    <div class="container partner-box">
                        <div class="row">
                            <div class="col-lg-2 col-sm-12 small-center-align">
                                <div class="justify-content-center align-self-center partner-container-image">
                                    <img src="../../assets/images/basscom_logo.png" height="80" width="200">
                                </div>
                            </div>
                            <div class="col-lg-10 col-sm-12">
                                <div class="justify-content-center ">
                                    <div class="partner-container-content">
                                        <div class="partner-container-text">
                                            "Smart Century Technologies" is a member of "BASSCOM" – Bulgarian Association of Software Companies.<br><br>
                                            "BASSCOM" is the industry association of leading Bulgarian software development companies. It's mission is to promote competitive advantages and long-term traditions in software development as well as to encourage acquisition of best practices to raise company excellence.<br><br>
                                            Visit <a href="https://basscom.org/">website.</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row partner-container">
                <div class="col-lg-12">
                    <div class="partner-container-title">
                        Burgas Free University
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12">
                    <div class="container partner-box">
                        <div class="row">
                            <div class="col-lg-2 col-sm-12 small-center-align">
                                <div class="justify-content-center align-self-center partner-container-image">
                                    <img src="../../assets/images/bfu_logo.png" height="100" width="100">
                                </div>
                            </div>
                            <div class="col-lg-10 col-sm-12">
                                <div class="justify-content-center ">
                                    <div class="partner-container-content">
                                        <div class="partner-container-text">
                                            "Smart Century Technologies" is a partner of Burgas Free University.<br><br>
                                            
                                            Visit <a href="https://www.bfu.bg/">website.</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>